import { InternalAppAction, RequestMessage } from '../../types/actions';
import { LogType } from '../types';

class LogErrorScreenRequest extends RequestMessage {
  value: { type: LogType; error: string; metadata?: { screenName?: string } };

  constructor(error: string, metadata?: Record<string, unknown>) {
    super(InternalAppAction.LOGGER_LOG, {
      type: LogType.ERROR_SCREEN,
      error,
      metadata,
    });
  }
}

export { LogErrorScreenRequest };
